import React from 'react'
import {
  BlankSlate,
  Description,
  PrimaryActionButton,
  SecondaryActionButton,
  SubTitle,
} from '@cjdev/visual-stack/lib/components/BlankSlate'
import './BaseErrorDisplay.css'

/**
 * Reusable error display component using CJ Visual Stack BlankSlate.
 *
 * @param {Object} props
 * @param {string} props.title - Main error title
 * @param {string} props.subtitle - Error category/code
 * @param {string} props.description - Detailed error description
 * @param {string} props.imgSrc - Path to error icon
 * @param {boolean} props.showSupport - Whether to show support button (default: true)
 * @param {Function} props.onPrimaryAction - Custom primary action handler
 * @param {Function} props.onSecondaryAction - Custom secondary action handler
 */
export const BaseErrorDisplay = ({
  title,
  subtitle,
  description,
  imgSrc,
  showSupport = true,
  onPrimaryAction,
  onSecondaryAction,
}) => {
  return (
    <BlankSlate
      title={title}
      headerGraphic={
        <img src={imgSrc} alt={'error graphic'} className={'headerGraphic'} />
      }
    >
      <SubTitle>
        <p>{subtitle}</p>
      </SubTitle>

      <Description>
        {description}
      </Description>

      <PrimaryActionButton
        label={'GO TO THE HOMEPAGE'}
        className={'primaryButton'}
        handler={onPrimaryAction || handleHomepage}
      />

      {showSupport && (
        <SecondaryActionButton
          label={'SUPPORT LINK'}
          handler={onSecondaryAction || handleSupport}
        />
      )}
    </BlankSlate>
  )
}

const handleHomepage = () => {
  window.location.href = 'https://www.cj.com'
}

const handleSupport = () => {
  window.location.href = 'https://www.cj.com/support'
}
